const PublicApi = "https://public.pitch2table.com";
const PrivateApi = "https://secure.pitch2table.com";

const endpoints = () => {
  const publicApi = PublicApi;
  const privateApi = PrivateApi;

  const server = () => {
    return {
      config: () => {
        return `${publicApi}/config`;
      },
    };
  };

  const users = () => {
    const server = privateApi;

    return {
      me: () => {
        return `${server}/v1/users/me`;
      },
      meNew: () => {
        return `${server}/users/me`;
      },
      followUp: () => {
        return `${server}/users/follow-up`;
      },
      avatar: () => {
        return `${server}/v1/users/me/avatar`;
      },
    };
  };

  const publishers = () => {
    const server = privateApi;

    return {
      me: () => {
        return `${server}/v1/publishers/me`;
      },
      new: () => {
        return `${server}/v1/publishers`;
      },
      /**
       * @param {import("@seabrookstudios/pitch2table-core").PublisherId} publisherId
       */
      info: (publisherId) => {
        return `${server}/v1/publishers/${publisherId}`;
      },
      /**
       * @param {import("@seabrookstudios/pitch2table-core").PublisherId} publisherId
       */
      contact: (publisherId) => {
        return `${server}/v1/publishers/${publisherId}/contact`;
      },
      /**
       * @param {import("@seabrookstudios/pitch2table-core").PublisherId} publisherId
       */
      logo: (publisherId) => {
        return `${server}/v1/publishers/${publisherId}/logo`;
      },
      /**
       * @param {import("@seabrookstudios/pitch2table-core").PublisherId} publisherId
       */
      submissions: (publisherId) => {
        return `${server}/v1/publishers/${publisherId}/submissions`;
      },
      /**
       * @param {import("@seabrookstudios/pitch2table-core").PublisherId} publisherId
       */
      game: (publisherId, gameId) => {
        return `${server}/v1/publishers/${publisherId}/games/${gameId}`;
      },
    };
  };

  const contacts = () => {
    const server = privateApi;

    return {
      get: (userId) => {
        return `${server}/v1/contacts/${userId}`;
      },
    };
  };

  const games = () => {
    const server = privateApi;

    return {
      create: () => {
        return `${server}/v1/games`;
      },
      get: () => {
        return `${server}/v1/games`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       */
      game: (gameId) => {
        return `${server}/v1/games/${gameId}`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       */
      sellSheet: (gameId) => {
        return `${server}/games/${gameId}/sellsheet`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       */
      sellSheetStart: (gameId) => {
        return `${server}/games/${gameId}/sellsheet/startUpload`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       */
      sellSheetFinish: (gameId) => {
        return `${server}/games/${gameId}/sellsheet/finishUpload`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       */
      cover: (gameId) => {
        return `${server}/v1/games/${gameId}/cover`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       * @param {import("@seabrookstudios/pitch2table-core").GameEditionId} editionId
       */
      editionCover: (gameId, editionId) => {
        return `${server}/games/${gameId}/editions/${editionId}/cover`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       * @param {import("@seabrookstudios/pitch2table-core").GameEditionId} editionId
       */
      editionCoverStart: (gameId, editionId) => {
        return `${server}/games/${gameId}/editions/${editionId}/cover/startUpload`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       * @param {import("@seabrookstudios/pitch2table-core").GameEditionId} editionId
       */
      editionCoverFinish: (gameId, editionId) => {
        return `${server}/games/${gameId}/editions/${editionId}/cover/finishUpload`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       */
      sellsheets: (gameId) => {
        return `${server}/v1/games/${gameId}/sellsheets`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       * @param {import("@seabrookstudios/pitch2table-core").AttachmentId} attachmentId
       */
      sellsheetsFeedback: (gameId, attachmentId) => {
        return `${server}/games/${gameId}/sellsheets/${attachmentId}/feedback`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       */
      contracts: (gameId) => {
        return `${server}/v1/games/${gameId}/contracts`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       */
      rules: (gameId) => {
        return `${server}/v1/games/${gameId}/rules`;
      },

      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       */
      rulesStart: (gameId) => {
        return `${server}/games/${gameId}/rules/startUpload`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       */
      rulesFinish: (gameId) => {
        return `${server}/games/${gameId}/rules/finishUpload`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       */
      asset: (gameId) => {
        return `${server}/games/${gameId}/asset`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       */
      assetStart: (gameId) => {
        return `${server}/games/${gameId}/asset/startUpload`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       */
      assetFinish: (gameId) => {
        return `${server}/games/${gameId}/asset/finishUpload`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       */
      publisherInterest: (gameId) => {
        return `${server}/v1/games/${gameId}/publishers`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       * @param {import("@seabrookstudios/pitch2table-core").PlayTestId} playTestId
       */
      playTestImages: (gameId, playTestId) => {
        return `${server}/games/${gameId}/tests/${playTestId}/photos`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       * @param {import("@seabrookstudios/pitch2table-core").PlayTestId} playTestId
       */
      playTestImagesStart: (gameId, playTestId) => {
        return `${server}/games/${gameId}/tests/${playTestId}/photoStartUpload`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       * @param {import("@seabrookstudios/pitch2table-core").PlayTestId} playTestId
       */
      playTestImagesFinish: (gameId, playTestId) => {
        return `${server}/games/${gameId}/tests/${playTestId}/photoFinishUpload`;
      },
    };
  };

  const publicGames = () => {
    const server = publicApi;

    return {
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       */
      game: (gameId) => {
        return `${server}/v1/games/${gameId}`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       */
      sellsheets: (gameId) => {
        return `${server}/v1/games/${gameId}/sellsheets`;
      },
      /**
       * @param {import("@seabrookstudios/types").GameId} gameId
       */
      rules: (gameId) => {
        return `${server}/v1/games/${gameId}/rules`;
      },
    };
  };

  return {
    contacts,
    games,
    publicGames,
    publishers,
    server,
    users,
  };
};

/**
 * @param {string} s3Location
 * @returns
 */
export const assetPath = (s3Location) => `https://assets.pitch2table.com/${s3Location}`;

/**
 * @param {import("@seabrookstudios/pitch2table-core").PublisherId} publisherId
 */
export const uploadContractToPublisher = (publisherId) => {
  return `${PrivateApi}/contact-book/publishers/${publisherId}/contracts`;
};

export default endpoints;
